import HomeFooterLegalNavigationLinks from "./HomeFooterLegalNavigationLinks";
import HomeFooterCopyrightText from "../../texts/homeScreen/HomeFooterCopyrightText";

export default function HomeFooterBottomLinks() {
    // Used in HomeFooter to display end section in the footer with
    // legal navigation links and copyright text

    // BUILD
    return (
        <div className={"w-full flex justify-between mt-[16px]"}>
            <HomeFooterLegalNavigationLinks />
            <HomeFooterCopyrightText />
        </div>
    )
}